import type { BackendHeaders } from '../types';

export const withIdempotencyKeyHeader = (props: {
  idempotencyKey: string;
}): BackendHeaders => ({
  // Fastify exposes request headers with lower-case keys; keep callers on the
  // same canonical spelling that api-core-node reads.
  'idempotency-key': props.idempotencyKey,
});
